export default __webpack_public_path__ + "static/media/infra.488c8234.png";